module.exports = __webpack_public_path__ + "static/media/rutgers 1.20f7c524.png";